import classnames from 'classnames'
import React, { FC } from 'react'

import productHelper from '@src/quince-site-common/src/helpers/productHelper'

import styles from './product-tags.module.scss'
import { ReadyToShip } from './ReadyToShip'

export const ProductTags: FC<{ applicableTags?: any[]; shopifyProductId?: number }> = ({
  applicableTags = [],
  shopifyProductId,
}) => {
  return (
    <ul className={styles.tagList}>
      {applicableTags.map(tag => {
        return (
          <li
            className={classnames(styles.tag, {
              [styles[`tag__${tag.tagType}`]]: tag.tagType,
            })}
            key={tag.value}
          >
            {productHelper.getTagValueWithFirstLetterUpperCase(tag.value)}
          </li>
        )
      })}
      <ReadyToShip shopifyProductId={shopifyProductId} />
    </ul>
  )
}
